export default __webpack_public_path__ + "static/media/and.3e1cde2c.jpg";